import { useContext } from 'react';

import { SidebarContext } from '.';

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  return { ...context };
};
